/* eslint-disable */

/*
 * Zoomer v3.1.0 - 2015-12-39
 * A jQuery plugin for smooth image exploration. Part of the formstone library.
 * http://classic.formstone.it/components/zoomer/
 *
 * Copyright 2015 Ben Plum; MIT Licensed
 *                Marc Brooks; MIT Licensed
 */

(function($, window) {
    'use strict';

    var $window = $(window),
        $instances,
        animating = false,
        animationFrameID,
        transformSupported = false;

    /**
     * @options
     * @param callback [function] <$.noop> ""
     * @param controls.postion [string] <"bottom"> "Position of default controls"
     * @param controls.zoomIn [string] <> "Custom zoom control selector"
     * @param controls.zoomOut [string] <> "Custom zoom control selector"
     * @param controls.next [string] <> "Custom pagination control selector"
     * @param controls.previous [string] <> "Custom pagination control selector"
     * @param customClass [string] <''> "Class applied to instance"
     * @param enertia [number] <0.2> "Zoom smoothing (0.1 = butter, 0.9 = sandpaper)"
     * @param increment [number] <0.01> "Zoom speed (0.01 = tortoise, 0.1 = hare)"
     * @param marginMin [] <> ""
     * @param marginMax [] <> ""
     * @param retina [boolean] <false> "Flag for retina image support"
     * @param source [string | object] <null> "Source image (string) or tiles (object)"
     * @param imageList [array] "Overriding image list through JSON"
     */
    var options = {
        callback: $.noop,
        controls: {
            position: 'bottom',
            zoomIn: null,
            zoomOut: null,
            next: null,
            previous: null
        },
        customClass: '',
        enertia: 0.2,
        increment: 0.01,
        marginMin: 30, // Min bounds
        marginMax: 100, // Max bounds
        retina: false,
        source: null,
        imageList: [],
        altList: [],
        isMobile: false
    };

    // Internal data
    var properties = {
        images: [],
        aspect: '',
        action: '',
        lastAction: '',
        keyDownTime: 0,
        marginReal: 0,
        originalDOM: '',

        // Gallery
        gallery: false,
        index: 0,

        // Tiles
        $tiles: null,
        tiled: false,
        tilesTotal: 0,
        tilesLoaded: 0,
        tiledColumns: 0,
        tiledRows: 0,
        tiledHeight: 0,
        tiledWidth: 0,
        tiledThumbnail: null,

        // Frame
        centerLeft: 0,
        centerTop: 0,
        frameHeight: 0,
        frameWidth: 0,

        // Original image
        naturalHeight: 0,
        naturalWidth: 0,
        imageRatioWide: 0,
        imageRatioTall: 0,

        // Dimensions
        minHeight: null,
        minWidth: null,
        maxHeight: 0,
        maxWidth: 0,

        // Bounds
        boundsTop: 0,
        boundsBottom: 0,
        boundsLeft: 0,
        boundsRight: 0,

        // Image
        imageWidth: 0,
        imageHeight: 0,
        imageLeft: 0,
        imageTop: 0,
        targetImageWidth: 0,
        targetImageHeight: 0,
        targetImageLeft: 0,
        targetImageTop: 0,
        oldImageWidth: 0,
        oldImageHeight: 0,

        // Positioner
        positionerLeft: 0,
        positionerTop: 0,
        targetPositionerLeft: 0,
        targetPositionerTop: 0,

        // Zoom
        zoomPositionLeft: 0,
        zoomPositionTop: 0,

        // Touch Support
        offset: null,
        touches: [],
        zoomPercentage: 1,

        pinchStartX0: 0,
        pinchStartX1: 0,
        pinchStartY0: 0,
        pinchStartY1: 0,

        pinchEndX0: 0,
        pinchEndX1: 0,
        pinchEndY0: 0,
        pinchEndY1: 0,

        lastPinchEndX0: 0,
        lastPinchEndY0: 0,
        lastPinchEndX1: 0,
        lastPinchEndY1: 0,

        pinchDeltaStart: 0,
        pinchDeltaEnd: 0
    };

    /**
     * @events
     * @event zoomer.loaded "Source media loaded"
     */

    var pub = {
        /**
         * @method
         * @name defaults
         * @description Sets default plugin options
         * @param opts [object] <{}> "Options object"
         * @example $.zoomer("defaults", opts);
         */
        defaults: function(opts) {
            options = $.extend(options, opts || {});
            return typeof this === 'object' ? $(this) : true;
        },

        /**
         * @method
         * @name destroy
         * @description Removes instance of plugin
         * @example $(".target").zoomer("destroy");
         */
        destroy: function() {
            var $targets = $(this).each(function(i, target) {
                var data = $(target).data('zoomer');

                if (data) {
                    data.$target
                        .removeClass('zoomer-element')
                        .data('zoomer', null)
                        .empty()
                        .append(data.originalDOM);
                }
                $(target).find('.swiper-slide').each(function(i, slide){
                    $(slide).data('slider-zoomer-data', null);
                });

            });

            $instances = $('.zoomer-element');
            if ($instances.length < 1) {
                _clearAnimation();
            }

            return $targets;
        },

        /**
         * @method
         * @name load
         * @description Loads source media
         * @param source [string | object] "Source image (string) or tiles (object)"
         * @example $(".target").zoomer("load", "path/to/image.jpg");
         */
        load: function(source) {
            return $(this).each(function(i, target) {
                var data = $(target).data('zoomer');

                if (data) {
                    data.source = source;
                    data.index = 0;
                    data = _normalizeSource(data);

                    _load(data);
                }
            });
        },

        /**
         * @method
         * @name resize
         * @description Resizes plugin instange
         * @example $(".target").zoomer("resize");
         */
        resize: function resize() {
            var $targets =  $(this).each(function(i, target) {
                var data = $(target).data('zoomer');
                var data = $(target).find('.swiper-slide-active').data('slider-zoomer-data') || data;

                if (data) {
                    data.isMobile = isMobile();
                    data.frameWidth = data.$target.outerWidth();
                    data.frameHeight = data.$target.outerHeight();
                    data.centerLeft = Math.round(data.frameWidth * 0.5);
                    data.centerTop = Math.round(data.frameHeight * 0.5);

                    // Set minHeight and minWidth to naturals sizes
                    data.minHeight = data.naturalHeight;
                    data.minWidth = data.naturalWidth;

                    // Recalculate minimum sizes only when the natural size of the image is bigger than the frame size - marginalReal
                    if (data.naturalHeight > data.frameHeight - data.marginReal || data.naturalWidth > data.frameWidth - data.marginReal) {
                        data = _setMinimums(data);
                    }

                    if (data.frameHeight > 0 && data.frameWidth > 0) {
                        var scaleX = data.minWidth / data.naturalWidth,
                            scaleY = data.minHeight / data.naturalHeight,
                            centerLeft = data.frameWidth / 2,
                            centerTop = data.frameHeight / 2;

                        if (data.isMobile) {
                            data.$zoomer.find('.swiper-slide').not('.swiper-slide-active').find('.holder')
                                    .css(_prefix('transform', 'translate3d(-50%, -50%, 0) scale(1, 1)'))
                                    .css({left: centerLeft+ 'px', top: centerTop + 'px', height: data.minHeight, width: data.minWidth});

                            data.$zoomer.find('.swiper-slide-active .holder')
                                    .css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`))
                                    .css({left: centerLeft+ 'px', top: centerTop + 'px', height: data.naturalHeight, width: data.naturalWidth });
                        } else {
                            data.$zoomer.find('.swiper-slide').find('.holder')
                                    .css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`))
                                    .css({left: centerLeft+ 'px', top: centerTop + 'px', height: data.naturalHeight, width: data.naturalWidth });
                        }
                    }
                }
            });

            return $targets;
        },

        /**
         * @method
         * @name unload
         * @description Unload image from plugins instances
         * @example $(".target").zoomer("unload");
         */
        unload: function() {
            return $(this).each(function() {
                var data = $(this).data('zoomer');

                if (data && typeof data.$image !== 'undefined') {
                    data.$image.remove();
                }
            });
        }
    };

    /**
     * @method private
     * @name _init
     * @description Initializes plugin
     * @param opts [object] "Initialization options"
     */
    function _init(opts) {
        // Settings
        opts = $.extend({}, options, properties, opts);

        transformSupported = false;

        // Apply to each element
        var $items = $(this);
        for (var i = 0, count = $items.length; i < count; i++) {
            _build($items.eq(i), opts);
        }

        // Start main animation loop
        $instances = $('.zoomer-element');
        _startAnimation();

        return $items;
    }

    /**
     * @method private
     * @name _build
     * @description Builds each instance
     * @param $target [jQuery object] "Target jQuery object"
     * @param data [object] <{}> "Options object"
     */
    function _build($target, data) {
        if (!$target.data('zoomer')) {
            data = $.extend({}, data, $target.data('zoomer-options'));

            var $targetParent = $target.parent(); // have to get the parent before we empty the target below
            data.$target = $target;

            data.marginReal = data.marginMin * 2;
            data.originalDOM = data.$target.html();

            if (data.imageList.length > 1) {
                data.source = [];
                $.each(data.imageList, function(index, val) {
                    data.source.push(val);
                });
                data.$target.empty();
            } else if (data.$target.find('img').length > 0) {
                data.source = [];
                data.$target.find('img').each(function() {
                    data.source.push($(this).attr('src'));
                });
                data.$target.empty();
            } else { // only one product image
                data.source = data.imageList;
            }

            data = _normalizeSource(data);

            // Assemble HTML
            var html = '<div class="zoomer ' + data.customClass + '">';
            html += '<div class="zoomer-positioner swiper">';
            html += '<div class="zoomer-holder swiper-wrapper">';
            html += '</div>';
            html += '<div class="swiper-pagination"></div>';
            html += '<div class="swiper-button-next"></div>';
            html += '<div class="swiper-button-prev"></div>';
            html += '</div>';
            html += '</div>';

            data.$zoomer = $(html);
            data.$target.addClass('zoomer-element').html(data.$zoomer);

            if (data.controls.zoomIn || data.controls.zoomOut || data.controls.next || data.controls.previous) {
                data.controls.$zoomIn = $(data.controls.zoomIn, $targetParent);
                data.controls.$zoomOut = $(data.controls.zoomOut, $targetParent);
                data.controls.$next = $(data.controls.next, $targetParent);
                data.controls.$previous = $(data.controls.previous, $targetParent);
            }

            // Cache jquery objects
            data.$positioner = data.$zoomer.find('.zoomer-positioner');
            data.$holder = data.$zoomer.find('.zoomer-holder');

            // Kick it off
            data.$target.data('zoomer', data);
            pub.resize.apply(data.$target);

            if (data.images.length > 0) {
                _load.apply(data.$target, [data]);
            }
        }
    }

    /**
     * @method private
     * @name _load
     * @description Delegates loading action
     * @param data [object] "Instance data"
     */
    function _load(data) {
        $('#modalZoomLoading').removeClass('d-none');

        //display the initial image after 1000ms
        setTimeout(function() {
            $('.zoomer-positioners').removeClass('d-none');
        }, 1000);

        // If gallery
        if (data.gallery) {
            data.$zoomer.addClass('zoomer-gallery');
        } else {
            data.$zoomer.removeClass('zoomer-gallery');
        }

        if (typeof data.$image !== 'undefined') {
            data.$holder.animate({ opacity: 0 }, 300, function() {
                pub.unload.apply(data.$target);
                _loadImage.apply(data.$target, [data, data.images[data.index]]);
            });
        } else {
            _loadImage.apply(data.$target, [data, data.images[parseInt(data.index)]]); // MS-654 added parseInt to change image 2.0 to 2
        }
    }

    /**
     * @method private
     * @name _loadImage
     * @description Handles loading an image or set of tiles
     * @param data [object] "Instance data"
     * @param source [string | object] "Source URL or object"
     */
    function _loadImage(data, source) { // MS-654 source was 'undefined' for all but image 0
        data.loading = true;

        // Cache current image
        data.$image = $('<img class="zoomer-image-loader swiper-image" />');
        data.$image
            .one('load.zoomer', data, _onImageLoad)
            .on('error', data, _tryAgain)
            .attr('src', source)
            .attr('alt', data.altList[0]);

        // If image has already loaded into cache, trigger load event
        if (data.$image[0].complete) {
            data.$image.trigger('load');
        }

    }

    /**
     * @method private
     * @name _onImageLoad
     * @description Handles image load
     * @param e [object] "Event data"
     */
    function _onImageLoad(e) {
        var data = e.data;

        data.naturalHeight = data.$image[0].naturalHeight;
        data.naturalWidth = data.$image[0].naturalWidth;

        data.$holder.css({
            height: data.naturalHeight,
            width: data.naturalWidth
        });

        // Set target, min, max to naturals sizes
        data.targetImageHeight = data.minHeight = data.maxHeight = data.naturalHeight;
        data.targetImageWidth = data.minWidth = data.maxWidth = data.naturalWidth;

        data.imageRatioWide = data.naturalWidth / data.naturalHeight;
        data.imageRatioTall = data.naturalHeight / data.naturalWidth;

        // Initial sizing to fit screen
        if (data.naturalHeight > data.frameHeight - data.marginReal || data.naturalWidth > data.frameWidth - data.marginReal) {
            data = _setMinimums(data);
            data.targetImageHeight = data.minHeight;
            data.targetImageWidth = data.minWidth;
        }

        // SET INITIAL POSITIONS
        data.positionerLeft = data.targetPositionerLeft = data.centerLeft;
        data.positionerTop = data.targetPositionerTop = data.centerTop;

        data.imageLeft = data.targetImageLeft = Math.round(-data.targetImageWidth / 2);
        data.imageTop = data.targetImageTop = Math.round(-data.targetImageHeight / 2);
        data.imageHeight = data.targetImageHeight;
        data.imageWidth = data.targetImageWidth;

        if (transformSupported) {
            var scaleX = data.imageWidth / data.naturalWidth,
                scaleY = data.imageHeight / data.naturalHeight;

            data.$positioner.css(_prefix('transform', 'translate3d(' + data.positionerLeft + 'px, ' + data.positionerTop + 'px, 0)'));
            data.$holder.css(_prefix('transform', 'translate3d(-50%, -50%, 0) scale(' + scaleX + ',' + scaleY + ')'));
        } else {
            data.$positioner.css({
                left: data.positionerLeft,
                top: data.positionerTop
            });
            data.$holder.css({
                left: data.imageLeft,
                top: data.imageTop,
                height: data.naturalHeight,
                width: data.naturalWidth
            });
        }

        var scaleX = data.imageWidth / data.naturalWidth,
            scaleY = data.imageHeight / data.naturalHeight,
            centerLeft = data.frameWidth / 2,
            centerTop = data.frameHeight / 2;

        var $imageSlider = $(`<div class="swiper-slide">
                        <div class="swiper-zoom-container">
                            <div class="zoomer-image swiper-zoom-target">
                                <div class="holder" style="transform: translate3d(-50%, -50%, 0) scale(1, 1); height: ${data.imageHeight}px; width: ${data.imageWidth}px; display: flex; justify-content: center; align-items: center; position: absolute; left: ${centerLeft}px; top: ${centerTop}px">
                                </div>
                            </div>
                        </div>
                    </div>`);

        $imageSlider.find('.holder').append(data.$image);

        data.$holder.append($imageSlider);

        data.$holder.animate({ opacity: 1 }, 1200);
        data.loading = false;

        // Run callback function
        if (data.onImageLoad) {
            data.onImageLoad.apply(data.$zoomer, [(data.imageWidth - data.minWidth) / (data.maxWidth - data.minWidth), data]);
        }

        // Start preloading
        if (data.gallery) {
            _preloadGallery(data);
        }

        $('#modalZoomLoading').addClass('d-none');
    }

    /**
     * @method private
     * @name _preloadGallery
     * @description Preloads previous and next images in gallery for faster rendering
     * @param data [object] "Instance Data"
     */
    function _preloadGallery(data) {

        let _loadImage = function(data, i, callback) {
            let $image = $(`<img class="zoomer-image-loader swiper-image" data-img-index="${i}" />`); //MS-654 i was 4.01 instead of 4
            $image
                .one('load.zoomer', data, _scaleImage.bind($image[0]))
                .on('error', data, _tryAgain)
                .attr('src', data.images[i])
                .attr('alt', data.altList[i]);

            if ($image[0].complete) {
                $image.trigger('load');
            }

            let scaleX = data.imageWidth / data.naturalWidth,
                scaleY = data.imageHeight / data.naturalHeight,
                centerLeft = data.frameWidth / 2,
                centerTop = data.frameHeight / 2;

            let $imageSlider = $(`<div class="swiper-slide">
                                        <div class="swiper-zoom-container">
                                            <div class="zoomer-image swiper-zoom-target">
                                                <div class="loadingDiv">
                                                   <div class="loading"></div>
                                                </div>
                                               <div class="holder" style="transform: translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY}); height: ${data.naturalHeight}px; width: ${data.naturalWidth}px; display: flex; justify-content: center; align-items: center; position: absolute; left: ${centerLeft}px; top: ${centerTop}px;">
                                               </div>
                                            </div>
                                         </div>
                                    </div>`);

            $imageSlider.data('slider-zoomer-data', null);
            $imageSlider.data('slider-zoomer-data', data);

            if (callback) {
                callback.apply(data.swiper, [$imageSlider]);
            }
        }

        var dataIndexInt = 0; //MS-654 force index to be an INTEGER for correct math here
        if (data.index > 0) {
            dataIndexInt = parseInt(data.index);
            for (let i = dataIndexInt- 1; i >= 0; i--) {
                // Cache current image
                _loadImage(data, i, data.prependImageCallback); // counts backwards starting from data-index (2.0 for example)
            }
        }
        if (data.index < data.images.length - 1) {
            for (let i = dataIndexInt + 1; i < data.images.length; i++) {
                // Cache current image
                _loadImage(data, i, data.appendImageCallback); // counts up starting from data-index, Must Be An Integer
            }
        }
    }


    /**
     * @method private
     * @name _scaleImage
     * @description Sets image holder dimensions once image has completely loaded
     * @param e [jQuery event] "event Data"
     */
    let _scaleImage = function (e) {
        let data = e.data;
        let image = this;

        data.naturalWidth = image.naturalWidth;
        data.naturalHeight = image.naturalHeight;

        data = _setMinimums(data);
        let scaleX = data.imageWidth / image.naturalWidth,
            scaleY = data.imageHeight / image.naturalHeight,
            centerLeft = data.frameWidth / 2,
            centerTop = data.frameHeight / 2;


        let $slider = data.$holder.find(`[data-swiper-slide-index="${$(image).data('img-index')}"]`);

        $slider.data('slider-zoomer-data', data);

        $slider.find('.holder').append(image);

        if (data.isMobile) {
            $(image).closest('.holder').css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`));
            $(image).closest('.holder').css({
                height: data.naturalHeight,
                width: data.naturalWidth,
                left: centerLeft,
                top: centerTop
            });
        } else {
            $(image).closest('.holder').css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`));
            $(image).closest('.holder').css({
                height: image.naturalHeight,
                width: image.naturalWidth,
                left: centerLeft,
                top: centerTop
            });
        }

        $slider.find('.loadingDiv').remove();

    }

    let _tryAgain = function (e)
    {
        let data = e.data;
        setTimeout(_reloadImg, 1000, this, data);
    }

    let _reloadImg = function(e, data)
    {
        let source = $(e).attr('src');
        $(e).attr('src', source);
    }

    /**
     * @method private
     * @name _setMinimums
     * @description Sets minimum dimensions
     * @param data [object] "Instance Data"
     */
    function _setMinimums(data) {
        if (data.naturalHeight > data.naturalWidth) {
            // Tall
            data.aspect = 'tall';

            data.minHeight = Math.round(data.frameHeight - data.marginReal);
            data.minWidth = Math.round(data.minHeight / data.imageRatioTall);

            if (data.minWidth > data.frameWidth - data.marginReal) {
                data.minWidth = Math.round(data.frameWidth - data.marginReal);
                data.minHeight = Math.round(data.minWidth / data.imageRatioWide);
            }
        } else {
            // Wide
            data.aspect = 'wide';

            data.minWidth = Math.round(data.frameWidth - data.marginReal);
            data.minHeight = Math.round(data.minWidth / data.imageRatioWide);

            if (data.minHeight > data.frameHeight - data.marginReal) {
                data.minHeight = Math.round(data.frameHeight - data.marginReal);
                data.minWidth = Math.round(data.minHeight / data.imageRatioTall);
            }
        }

        return data;
    }

    /**
     * @method private
     * @name _render
     * @description Main animation loop
     */
    function _render() {
        for (var i = 0, count = $instances.length; i < count; i++) {
            var $slider = $instances.eq(i).find('.swiper-slide-active');
            var data = $slider.data('slider-zoomer-data') || $instances.eq(i).data('zoomer');

            if (typeof data === 'object') {
                // Update image and position values
                data = _setMinimums(data);
                //data = _updateValues(data);
                data.lastAction = data.action;

                // Update DOM
                var scaleX = data.imageWidth / data.naturalWidth,
                    scaleY = data.imageHeight / data.naturalHeight,
                    centerLeft = data.frameWidth / 2,
                    centerTop = data.frameHeight / 2;

                //data.$positioner.css(_prefix('transform', 'translate3d(' + data.positionerLeft + 'px, ' + data.positionerTop + 'px, 0)'));
                data.$positioner.css({
                    left: 0,
                    top: 0,
                });
                data.$holder.css({
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '80vh'
                });
                $slider.find('.holder')
                    .css({
                        height: data.naturalHeight,
                        width: data.naturalWidth,
                        left: centerLeft,
                        top: centerTop
                    })
                    .css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`));



                // Run callback function
                if (data.callback) {
                    data.callback.apply(data.$zoomer, [(data.imageWidth - data.minWidth) / (data.maxWidth - data.minWidth)]);
                }

                if (data.toggleAnimation != undefined) {
                    animating = data.toggleAnimation;
                }
            }
        }
    }

    /**
     * @method private
     * @name _updateValues
     * @description Updates current image values
     * @param data [object] "Instance Data"
     */
    function _updateValues(data) {
        // Update values based on current action
        if (data.action === 'zoom_in' || data.action === 'zoom_out') {
            // Calculate change
            data.keyDownTime += data.increment;
            var delta = (data.action === 'zoom_out' ? -1 : 1) * Math.round(data.imageWidth * data.keyDownTime - data.imageWidth);

            if (data.aspect === 'tall') {
                data.targetImageHeight += delta;
                data.targetImageWidth = Math.round(data.targetImageHeight / data.imageRatioTall);
            } else {
                data.targetImageWidth += delta;
                data.targetImageHeight = Math.round(data.targetImageWidth / data.imageRatioWide);
            }
        }

        // Check Max and Min image values; recenter if too small
        if (data.aspect === 'tall') {
            if (data.targetImageHeight < data.minHeight) {
                data.targetImageHeight = data.minHeight;
                data.targetImageWidth = Math.round(data.targetImageHeight / data.imageRatioTall);
            } else if (data.targetImageHeight > data.maxHeight) {
                data.targetImageHeight = data.maxHeight;
                data.targetImageWidth = Math.round(data.targetImageHeight / data.imageRatioTall);
            }
        } else {
            if (data.targetImageWidth < data.minWidth) {
                data.targetImageWidth = data.minWidth;
                data.targetImageHeight = Math.round(data.targetImageWidth / data.imageRatioWide);
            } else if (data.targetImageWidth > data.maxWidth) {
                data.targetImageWidth = data.maxWidth;
                data.targetImageHeight = Math.round(data.targetImageWidth / data.imageRatioWide);
            }
        }

        // Calculate new dimensions
        data.targetImageLeft = Math.round(-data.targetImageWidth * 0.5);
        data.targetImageTop = Math.round(-data.targetImageHeight * 0.5);

        if (data.action === 'drag' || data.action === 'pinch') {
            data.imageWidth = data.targetImageWidth;
            data.imageHeight = data.targetImageHeight;
            data.imageLeft = data.targetImageLeft;
            data.imageTop = data.targetImageTop;
        } else {
            data.imageWidth += Math.round((data.targetImageWidth - data.imageWidth) * data.enertia);
            data.imageHeight += Math.round((data.targetImageHeight - data.imageHeight) * data.enertia);
            data.imageLeft += Math.round((data.targetImageLeft - data.imageLeft) * data.enertia);
            data.imageTop += Math.round((data.targetImageTop - data.imageTop) * data.enertia);
        }

        // Check bounds of current position and if big enough to drag
        // Set bounds
        data.boundsLeft = Math.round(data.frameWidth - data.targetImageWidth * 0.5 - data.marginMax);
        data.boundsRight = Math.round(data.targetImageWidth * 0.5 + data.marginMax);
        data.boundsTop = Math.round(data.frameHeight - data.targetImageHeight * 0.5 - data.marginMax);
        data.boundsBottom = Math.round(data.targetImageHeight * 0.5 + data.marginMax);

        // Check dragging bounds
        if (data.targetPositionerLeft < data.boundsLeft) {
            data.targetPositionerLeft = data.boundsLeft;
        }
        if (data.targetPositionerLeft > data.boundsRight) {
            data.targetPositionerLeft = data.boundsRight;
        }
        if (data.targetPositionerTop < data.boundsTop) {
            data.targetPositionerTop = data.boundsTop;
        }
        if (data.targetPositionerTop > data.boundsBottom) {
            data.targetPositionerTop = data.boundsBottom;
        }

        // Zoom to visible area of image
        if (data.zoomPositionTop > 0 && data.zoomPositionLeft > 0) {
            data.targetPositionerLeft = data.centerLeft - data.targetImageLeft - data.targetImageWidth * data.zoomPositionLeft;
            data.targetPositionerTop = data.centerTop - data.targetImageTop - data.targetImageHeight * data.zoomPositionTop;
        }

        if (data.action !== 'pinch') {
            // Recenter when small enough
            if (data.targetImageWidth < data.frameWidth) {
                data.targetPositionerLeft = data.centerLeft;
            }
            if (data.targetImageHeight < data.frameHeight) {
                data.targetPositionerTop = data.centerTop;
            }
        }

        // Calculate new positions
        if (data.action === 'drag' || data.action === 'pinch') {
            data.positionerLeft = data.targetPositionerLeft;
            data.positionerTop = data.targetPositionerTop;
        } else {
            data.positionerLeft += Math.round((data.targetPositionerLeft - data.positionerLeft) * data.enertia);
            data.positionerTop += Math.round((data.targetPositionerTop - data.positionerTop) * data.enertia);
        }

        data.oldImageWidth = data.imageWidth;
        data.oldImageHeight = data.imageHeight;

        return data;
    }

    /**
     * @method private
     * @name _nextImage
     * @description Handles next button click
     * @param e [object] "Event Data"
     */
    function _nextImage(e) {
        return;
        var data = e.data;

        if (!data.loading && data.index + 1 < data.images.length) {
            data.index++;
            _load.apply(data.$target, [data]);
        } else {
            data.index = 0;
            _load.apply(data.$target, [data]);
        }

        // Run callback function
        if (data.zoomNextPrevCallback) {
            data.zoomNextPrevCallback.apply(data.$zoomer, [data]);
        }
    }

    /**
     * @method private
     * @name _previousImage
     * @description Handles previous button click
     * @param e [object] "Event Data"
     */
    function _previousImage(e) {
        return;
        var data = e.data;

        if (!data.loading && data.index - 1 >= 0) {
            data.index--;
            _load.apply(data.$target, [data]);
        } else {
            data.index = data.images.length - 1;
            _load.apply(data.$target, [data]);
        }

        // Run callback function
        if (data.zoomNextPrevCallback) {
            data.zoomNextPrevCallback.apply(data.$zoomer, [data]);
        }
    }

     /**
     * @method private
     * @name _normalizeSource
     * @description Normalizes source string or object
     * @param data [object] "Instance Data"
     */
    function _normalizeSource(data) {
        data.tiled = false;
        data.gallery = false;

        if (!data.source) {
            data.images = data.imageList;
        } else if (typeof data.source === 'string') {
            data.images = [data.source];
        } else {
            if (typeof data.source[0] === 'string') {
                data.images = data.source;
                if (data.images.length > 1) {
                    data.gallery = true;
                }
            } else {
                data.tiledThumbnail = data.source.thumbnail;
                data.images = [data.source.tiles];
                data.tiled = true;
            }
        }

        return data;
    }

    /**
     * @method private
     * @name _startAnimation
     * @description Starts main animation loop
     */
    function _startAnimation() {
        if (!animating) {
            animating = true;
            _onAnimate();
        }
    }

    /**
     * @method private
     * @name _clearAnimation
     * @description End main animation loop
     */
    function _clearAnimation() {
        animating = false;
    }

    /**
     * @method private
     * @name _onAnimate
     * @description Handles RAF
     */
    function _onAnimate() {
        if (animating) {
            animationFrameID = window.requestAnimationFrame(_onAnimate);
            _render();
        }
    }

    /**
     * @method private
     * @name _prefix
     * @description Builds vendor-prefixed styles
     * @param property [string] "Property to prefix"
     * @param value [string] "Property value"
     * @return [string] "Vendor-prefixed style"
     */
    function _prefix(property, value) {
        var r = {};

        r['-webkit-' + property] = value;
        r['-moz-' + property] = value;
        r['-ms-' + property] = value;
        r['-o-' + property] = value;
        r[property] = value;

        return r;
    }

    /**
     * @method private
     * @name _getTransform3DSupport
     * @description Determines if transforms are support
     * @return [boolean] "True if transforms supported"
     */
    function _getTransform3DSupport() {
        /* http://stackoverflow.com/questions/11628390/how-to-detect-css-translate3d-without-the-webkit-context */
        /*
		var prop = "transform",
			val = "translate3d(0px, 0px, 0px)",
			test = /translate3d\(0px, 0px, 0px\)/g,
			$div = $("<div>");

		$div.css(_prefix(prop, val));
		var check = $div[0].style.cssText.match(test);

		return (check !== null && check.length > 0);
		*/

        /* http://stackoverflow.com/questions/5661671/detecting-transform-translate3d-support/12621264#12621264 */
        var el = document.createElement('p'),
            has3d,
            transforms = {
                webkitTransform: '-webkit-transform',
                OTransform: '-o-transform',
                msTransform: '-ms-transform',
                MozTransform: '-moz-transform',
                transform: 'transform'
            };

        document.body.insertBefore(el, null);
        for (var t in transforms) {
            if (el.style[t] !== undefined) {
                el.style[t] = 'translate3d(1px,1px,1px)';
                has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
            }
        }
        document.body.removeChild(el);

        return has3d !== undefined && has3d.length > 0 && has3d !== 'none';
    }

    function isMobile () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var idx = 0;
        var isMobile = false;
        var userAgent = navigator.userAgent.toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
            idx++;
        }
        return isMobile;
    }

    $.fn.swiper = function(method) {
        if (pub[method]) {
            return pub[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return _init.apply(this, arguments);
        }
        return this;
    };

    $.swiper = function(method) {
        if (method === 'defaults') {
            pub.defaults.apply(this, Array.prototype.slice.call(arguments, 1));
        }
    };
})(jQuery, window);
